import React, { useEffect, useState } from 'react';
import { StaticTimer } from './timer';
import { LapPair, Runner, RunnerRow } from './new-timer';
import BackIcon from '@material-ui/icons/ArrowBack';
import TrashIcon from '@material-ui/icons/Delete';
import { useHistory } from 'react-router';
import { Modal } from './modal';
import { EditLap } from './edit-lap';

export function SavePage() {
  const [selected, setSelected] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<string | undefined>(undefined);
  const [editModal, setEditModal] = useState<LapPair | undefined>();
  const history = useHistory()
  const keys = Object.keys(localStorage).filter(key => key.substring(0, 11) === 'Saved Watch');
  const stored = keys.map((k) => ({ key: k, value: JSON.parse(localStorage.getItem(k) || '{}') }));
  const sorted = stored.sort((a, b) => (b.value.startTime - a.value.startTime));
  console.log(sorted)

  useEffect(() => {
    console.log(selected)
  }, selected)

  function deleteWatch() {
    localStorage.removeItem(deleteModal || '');
    setDeleteModal(undefined);
  }

  function editLap(key: string, newRunners: Runner[]) {
    const current = JSON.parse(localStorage.getItem(key) || '{}');
    localStorage.setItem(key, JSON.stringify({...current, runners: newRunners}))
  }

  if (selected) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'fit-content', paddingTop: '1rem' }}>
        <button onClick={() => setSelected(undefined)} style={{ position: 'absolute', top: '.75rem', left: '.75rem', backgroundColor: '#c96363', fontSize: '1.5em', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '999px' }}><BackIcon fontSize='inherit' /></button>
        <h1 className='title'>{selected?.value.name}</h1>
        <StaticTimer time={selected?.value.stopTime - selected?.value.startTime} />
        {selected?.value.runners?.map((runner: Runner) =>
          <RunnerRow
            onRowClick={() => { }}
            onLapClick={() => { }}
            onStopClick={() => { }}
            runner={runner}
            startTime={selected?.value.startTime}
            setEditModalOpen={(r) => setEditModal(r)}
            buttonless
          />
        )}
        {editModal &&
          <EditLap runners={selected?.value.runners || []} submit={(r) => editLap(selected?.key || '', r)} lap={editModal} startTime={selected?.value.startTime || 0} close={() => setEditModal(undefined)} />
        }
      </div>
    )
  } else {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingInline: '4rem', paddingBlock: '3rem', paddingTop: '2em' }}>
        <h1>Saved</h1>
        <button onClick={() => history.push('/')} style={{ position: 'absolute', top: '.75rem', left: '.75rem', backgroundColor: '#c96363', fontSize: '1.5em', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '999px' }}><BackIcon fontSize='inherit' /></button>
        {sorted.map((watch) => (
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', textAlign: 'left', paddingInline: '1rem', lineHeight: '1.3rem', borderRadius: '1rem', paddingTop: '.25rem', paddingBottom: '.5rem', marginBottom: '1rem', border: '2px solid black', width: '100%' }}>
            <div onClick={() => setSelected(watch)} style={{ flexGrow: 1, cursor: 'pointer' }}>
              <p style={{ marginBottom: '0px', fontWeight: 'bold' }}>{watch.value.name}</p>
              <p style={{ marginBottom: '0px' }}>{new Date(watch.value.startTime).toLocaleString()}</p>
              <p style={{ marginBottom: '0px' }}>{`${watch.value.runners.length} runner${watch.value.runners.length === 1 ? '' : 's'}, ${watch.value.runners.reduce((sum: number, r: Runner) => sum + r.laps.length + 1, 0)} laps`}</p>
            </div>
            <button onClick={() => setDeleteModal(watch.key)} style={{ backgroundColor: '#0000', border: 'none' }}>
              <TrashIcon />
            </button>
          </div>
        ))}
        {deleteModal && <Modal title='Delete' primaryButtonText='Delete' primaryButtonClick={deleteWatch} secondaryButtonText='Cancel' secondaryButtonClick={() => setDeleteModal(undefined)}>
          <p style={{ textAlign: 'center' }}>Are you sure you want to permanently delete this watch?</p>
        </Modal>}
      </div>
    )
  }
}